export const assetURLs = {
  // TODO: Delete the references -> Not used as of Jan 2020
  hotelTenPercentSavings:
    '/m/fly/search/public/assets/images/10-percent-off.png',
  sponsoredAirlineImage:
    '/m/fly/search/public/assets/images/air_canada_A220_2.jpg'
}
